import React, { useState, useEffect } from "react";

const LeadAcceptance = () => {
    const [leads, setLeads] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);
    const [filter, setFilter] = useState("all"); // all, accepted, paid


    useEffect(() => {

        const mockLeads = [
            {
                id: 63,
                orderId: 63,
                budget: "5000",
                paymentAmount: "50",
                event: "EVENT",
                eventType: "ENGAGEMENT",
                eventDate: "23/02/2026",
                eventTime: "13:15",
                fullName: "Raj",
                name: "Raj",
                phoneNumber: "8085270852",
                mobile: "8085270852",
                email: "nag@gmail.com",
                vegPlates: 80,
                nonVegPlates: 10,
                fullAddress: "manjeera , eseva",
                city: "hyderabad",
                state: "telangana",
                country: "india",
                pincode: "500072",
                additionalRequests: "dfgg",
                adminPermision: true,
                items: [
                    "mutton",
                    "Veg Manchurian",
                    "Paneer Tikka",
                    "Paneer 65",
                    "Mushroom 65",
                    "dosa",
                    "Gobi Manchurian",
                    "Baby Corn Manchurian",
                    "Chiken"
                ],
                addOns: [],

                vendorResponses: [
                    {
                        vendorId: 101,
                        vendorName: "Fresh Foods Catering",
                        email: "freshfoods@gmail.com",
                        phone: "9876543210",
                        location: "Hyderabad",
                        accepted: true,
                        acceptedDate: "22/02/2026",
                        paid: true,
                        paidDate: "22/02/2026",
                        paymentAmount: "500",
                        paymentMethod: "UPI",
                        transactionId: "TXN123456789",
                        rating: 4.5,
                        feedback: "Good customer, will serve well"
                    },
                    {
                        vendorId: 102,
                        vendorName: "Spice Garden",
                        email: "spicegarden@gmail.com",
                        phone: "9123456780",
                        location: "Bangalore",
                        accepted: true,
                        acceptedDate: "22/02/2026",
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: "Accepted but payment pending"
                    },
                    {
                        vendorId: 103,
                        vendorName: "Royal Dine Services",
                        email: "royaldine@gmail.com",
                        phone: "9988776655",
                        location: "Chennai",
                        accepted: false,
                        acceptedDate: null,
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: null
                    },
                    {
                        vendorId: 104,
                        vendorName: "Urban Tadka Caterers",
                        email: "urbantadka@gmail.com",
                        phone: "9012345678",
                        location: "Mumbai",
                        accepted: true,
                        acceptedDate: "21/02/2026",
                        paid: true,
                        paidDate: "21/02/2026",
                        paymentAmount: "500",
                        paymentMethod: "Credit Card",
                        transactionId: "TXN987654321",
                        rating: 5,
                        feedback: "Excellent communication"
                    },
                    {
                        vendorId: 105,
                        vendorName: "Grand Feast Events",
                        email: "grandfeast@gmail.com",
                        phone: "9090909090",
                        location: "Delhi",
                        accepted: false,
                        acceptedDate: null,
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: null
                    }
                ]
            },
            {
                id: 64,
                orderId: 64,
                budget: "8000",
                paymentAmount: "80",
                event: "WEDDING",
                eventType: "RECEPTION",
                eventDate: "25/02/2026",
                eventTime: "19:00",
                fullName: "Priya Sharma",
                name: "Priya Sharma",
                phoneNumber: "9876543210",
                mobile: "9876543210",
                email: "priya@gmail.com",
                vegPlates: 100,
                nonVegPlates: 50,
                fullAddress: "Green Park, Delhi",
                city: "Delhi",
                state: "Delhi",
                country: "india",
                pincode: "110001",
                additionalRequests: "Need vegetarian options",
                adminPermision: true,
                items: [
                    "Paneer Butter Masala",
                    "Dal Makhani",
                    "Naan",
                    "Gulab Jamun",
                    "Chicken Biryani"
                ],
                addOns: [],
                vendorResponses: [
                    {
                        vendorId: 101,
                        vendorName: "Fresh Foods Catering",
                        email: "freshfoods@gmail.com",
                        phone: "9876543210",
                        location: "Hyderabad",
                        accepted: true,
                        acceptedDate: "23/02/2026",
                        paid: true,
                        paidDate: "23/02/2026",
                        paymentAmount: "800",
                        paymentMethod: "Bank Transfer",
                        transactionId: "TXN555555555",
                        rating: 4,
                        feedback: "Will manage the event"
                    },
                    {
                        vendorId: 105,
                        vendorName: "Grand Feast Events",
                        email: "grandfeast@gmail.com",
                        phone: "9090909090",
                        location: "Delhi",
                        accepted: true,
                        acceptedDate: "23/02/2026",
                        paid: false,
                        paidDate: null,
                        paymentAmount: null,
                        paymentMethod: null,
                        transactionId: null,
                        rating: null,
                        feedback: "Accepted, waiting for payment"
                    }
                ]
            }
        ];

        setLeads(mockLeads);
    }, []);


    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return dateString;
    };


    const getFilteredVendors = (vendorResponses) => {
        switch (filter) {
            case "accepted":
                return vendorResponses.filter(v => v.accepted === true);
            case "paid":
                return vendorResponses.filter(v => v.paid === true);
            default:
                return vendorResponses;
        }
    };


    const getAllVendorResponses = () => {
        let allResponses = [];
        leads.forEach(lead => {
            lead.vendorResponses.forEach(vendor => {
                allResponses.push({
                    ...vendor,
                    enquiryId: lead.orderId,
                    customerName: lead.fullName,
                    eventType: lead.eventType,
                    eventDate: lead.eventDate,
                    budget: lead.budget
                });
            });
        });
        return allResponses;
    };


    const getFilteredResponses = () => {
        const allResponses = getAllVendorResponses();
        switch (filter) {
            case "accepted":
                return allResponses.filter(v => v.accepted === true);
            case "paid":
                return allResponses.filter(v => v.paid === true);
            default:
                return allResponses;
        }
    };


    const getStatistics = () => {
        const allResponses = getAllVendorResponses();
        const total = allResponses.length;
        const accepted = allResponses.filter(v => v.accepted).length;
        const paid = allResponses.filter(v => v.paid).length;
        const pending = accepted - paid;

        return { total, accepted, paid, pending };
    };


    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };


    const styles = {
        container: {
            padding: "20px",
            backgroundColor: "#f5f5f5",
            minHeight: "100vh",
            width: "100%",
            boxSizing: "border-box"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            gap: "15px"
        },
        title: {
            fontSize: window.innerWidth < 768 ? "20px" : "24px",
            fontWeight: "bold",
            color: "#333",
            margin: 0,
            textAlign: window.innerWidth < 768 ? "center" : "left"
        },
        filterContainer: {
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center"
        },
        filterLabel: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#666"
        },
        filterSelect: {
            padding: "10px 16px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "14px",
            backgroundColor: "white",
            cursor: "pointer",
            minWidth: "180px",
            outline: "none",
            transition: "border-color 0.3s ease",
            ":focus": {
                borderColor: "rgb(230 109 51)"
            }
        },
        statsContainer: {
            display: "flex",
            gap: window.innerWidth < 768 ? "10px" : "20px",
            flexWrap: "wrap",
            marginBottom: "20px",
            padding: "15px",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        },
        statItem: {
            display: "flex",
            alignItems: "center",
            gap: "5px"
        },
        statBadge: {
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            whiteSpace: "nowrap"
        },
        tableContainer: {
            width: "100%",
            overflowX: "auto",
            borderRadius: "8px",
            border: "1px solid #ddd",
            backgroundColor: "white"
        },
        table: {
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "800px"
        },
        tableHeader: {
            backgroundColor: "rgb(230 109 51)",
            color: "white",
            padding: "12px",
            textAlign: "left",
            fontSize: window.innerWidth < 768 ? "12px" : "14px",
            whiteSpace: "nowrap"
        },
        tableCell: {
            padding: window.innerWidth < 768 ? "8px" : "12px",
            borderBottom: "1px solid #ddd",
            fontSize: window.innerWidth < 768 ? "12px" : "14px"
        },
        acceptedBadge: {
            backgroundColor: "#d4edda",
            color: "#155724",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            display: "inline-block"
        },
        paidBadge: {
            backgroundColor: "#cce5ff",
            color: "#004085",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            display: "inline-block"
        },
        pendingBadge: {
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            display: "inline-block"
        },
        rejectedBadge: {
            backgroundColor: "#f8d7da",
            color: "#721c24",
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            display: "inline-block"
        }
    };

    const stats = getStatistics();
    const filteredResponses = getFilteredResponses();

    return (
        <div style={styles.container}>

            <div style={styles.header}>

                <div style={styles.filterContainer}>
                    <label htmlFor="filter-select" style={styles.filterLabel}>
                        Filter by:
                    </label>
                    <select
                        id="filter-select"
                        value={filter}
                        onChange={handleFilterChange}
                        style={styles.filterSelect}
                    >
                        <option value="all">All Vendors</option>
                        <option value="accepted">Accepted Only</option>
                        <option value="paid">Paid Only</option>
                    </select>
                </div>
            </div>


            <div style={styles.statsContainer}>
                <div style={styles.statItem}>
                    <span style={{ color: "#666", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>Total Vendors:</span>
                    <span style={{ fontWeight: "bold", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>{stats.total}</span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#d4edda", color: "#155724" }}>
                        Accepted: {stats.accepted}
                    </span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#cce5ff", color: "#004085" }}>
                        Paid: {stats.paid}
                    </span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#fff3cd", color: "#856404" }}>
                        Pending Payment: {stats.pending}
                    </span>
                </div>
            </div>


            <div style={styles.tableContainer}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.tableHeader}>Enquiry ID</th>
                            <th style={styles.tableHeader}>Vendor ID</th>
                            <th style={styles.tableHeader}>Vendor Name</th>
                            <th style={styles.tableHeader}>Location</th>
                            <th style={styles.tableHeader}>Status</th>
                            <th style={styles.tableHeader}>Accepted Date</th>
                            <th style={styles.tableHeader}>Payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredResponses.map((vendor, index) => (
                            <tr key={`${vendor.enquiryId}-${vendor.vendorId}`}>
                                <td style={styles.tableCell}>
                                    <strong>#{vendor.enquiryId}</strong>
                                </td>
                                <td style={styles.tableCell}>
                                    <strong>#{vendor.vendorId}</strong>
                                </td>
                                <td style={styles.tableCell}>
                                    {vendor.vendorName}
                                </td>
                                <td style={styles.tableCell}>{vendor.location}</td>
                                <td style={styles.tableCell}>
                                    {vendor.accepted ? (
                                        <span style={styles.acceptedBadge}>Accepted</span>
                                    ) : (
                                        <span style={styles.rejectedBadge}>Rejected</span>
                                    )}
                                </td>
                                <td style={styles.tableCell}>
                                    {vendor.acceptedDate || "N/A"}
                                </td>
                                <td style={styles.tableCell}>
                                    {vendor.paid ? (
                                        <span style={styles.paidBadge}>Paid</span>
                                    ) : vendor.accepted ? (
                                        <span style={styles.pendingBadge}>Pending</span>
                                    ) : (
                                        "N/A"
                                    )}
                                </td>
                            </tr>
                        ))}
                        {filteredResponses.length === 0 && (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                                    No vendors match the selected filter
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LeadAcceptance;